import { convertPriceFromCent, convertPriceToCent } from "@/lib/utils";

interface AmountInputProps {
  value: number;
  onChange: (valueInCents: number) => void;
  label: string;
  placeholder?: string;
}

const AmountInput: React.FC<AmountInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
}) => {
  const displayValue = value > 0 ? convertPriceFromCent(value).toString() : "";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (raw === "") {
      onChange(0);
      return;
    }
    const numericValue = parseInt(raw, 10);
    if (!isNaN(numericValue)) {
      onChange(convertPriceToCent(numericValue));
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-card-foreground">{label}</label>
      <input
        type="text"
        inputMode="numeric"
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full rounded-lg border border-border px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
      />
    </div>
  );
};

export default AmountInput;
